var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "panel" },
      [
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "form__item--row" },
              [
                _c("StoreConnectedSelect", {
                  attrs: {
                    store: _vm.store,
                    name: "paymentType",
                    options: _vm.paymentOptions,
                    placeholder: "Select Payment Option"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div")
        ]),
        _vm._v(" "),
        _vm.showCreditCardForm ? _c("CreditCardForm") : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.hasPowerOne && !_vm.meetsCartonMinimum
      ? _c(
          "div",
          {
            staticClass:
              "battery-store__unmet-minimum h-helper-text h-center-align"
          },
          [
            _vm._v(
              "There is a 10 carton minimum purchase requirement for Power One orders"
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "battery-store__nav-row h-center-align" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { disabled: !_vm.isFormValid || !_vm.isOrderValid },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.nextStep($event)
            }
          }
        },
        [_vm._v("Submit Order")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid battery-order-form__row battery-order-form__row--header"
      },
      [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "battery-order-view__cell battery-order-view__cell--header"
          },
          [_vm._v("Billing Info")]
        ),
        _vm._v(" "),
        _c("div")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }